(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('attendant', {
            parent: 'entity',
            url: '/attendant?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.attendant.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/attendant/attendants.html',
                    controller: 'AttendantController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('attendant');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('attendant-detail', {
            parent: 'entity',
            url: '/attendant/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.attendant.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/attendant/attendant-detail.html',
                    controller: 'AttendantDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('attendant');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Attendant', function($stateParams, Attendant) {
                    return Attendant.get({id : $stateParams.id});
                }]
            }
        })
        .state('attendant.new', {
            parent: 'attendant',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attendant/attendant-dialog.html',
                    controller: 'AttendantDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                phone: null,
                                email: null,
                                isWrongPhone: null,
                                isWrongContact: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('attendant', null, { reload: true });
                }, function() {
                    $state.go('attendant');
                });
            }]
        })
        .state('attendant.edit', {
            parent: 'attendant',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attendant/attendant-dialog.html',
                    controller: 'AttendantDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Attendant', function(Attendant) {
                            return Attendant.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('attendant', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('attendant.delete', {
            parent: 'attendant',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/attendant/attendant-delete-dialog.html',
                    controller: 'AttendantDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Attendant', function(Attendant) {
                            return Attendant.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('attendant', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
